import * as React from 'react';
import {RegulationsContext} from './RegulationsContext';

/**
 * See the Regulation's Context type for important info.
 */
export const useRegulationsContext = () => React.useContext(RegulationsContext);
